import { useAppSelector } from '@app/app.hook'
import { findRouteAll } from '@app/app.method'
import { selectStrings } from '@app/slices/slice.app'
import { SystemModule } from '@login/type'
import { useCallback } from 'react'

export const useValidateRouteAll = () => {
    const strings = useAppSelector(selectStrings)
    const callback = useCallback((arr: SystemModule[], route: string, showToast: boolean) => {
        if (arr.length) {
            const foundRoute = findRouteAll(
                arr, route
            )

            // NOTE: not all need to show a toast error.
            // only do this error toast method AFTER authentication.
            if (foundRoute?.route) {
                // console.log('route found.', foundRoute)
                return foundRoute
            } else {
                if (strings.login?.message.error?.route_denied && showToast) {
                    const message = [
                        route,
                        ':',
                        strings.login?.message.error.route_denied
                    ].join(' ')
                    // toast.error(
                    //     message,
                    //     { ...TOASTIFY_DEFAULT_OPTIONS }
                    // )
                    console.error(message)
                }
            }
        }

        return {
            route: '',
            showMenu: false
        }
    }, [strings])

    return callback
}
